export interface Feature {
  icon: string;
  titleKey: string;
  descriptionKey: string;
}

export const features: Feature[] = [
  {
    icon: "icon1",
    titleKey: "titleFeature1",
    descriptionKey: "descriptionFeature1",
  },
  {
    icon: "icon2",
    titleKey: "titleFeature2",
    descriptionKey: "descriptionFeature2",
  },
  {
    icon: "icon3",
    titleKey: "titleFeature3",
    descriptionKey: "descriptionFeature3",
  },
  {
    icon: "icon4",
    titleKey: "titleFeature4",
    descriptionKey: "descriptionFeature4",
  },
  {
    icon: "icon5",
    titleKey: "titleFeature5",
    descriptionKey: "descriptionFeature5",
  },
  {
    icon: "icon6",
    titleKey: "titleFeature6",
    descriptionKey: "descriptionFeature6",
  },
];
